// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"530":"718668de","551":"37a06f2e","809":"8caf3855","873":"c27ad077","955":"c429bb5d"}[chunkId] + ".chunk.js";
};